import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class InvalidInstitutionIDError extends ExpectedError {
  static override _class = 'InvalidInstitutionIDError';

  public constructor(institutionID?: string) {
    super('InvalidInstitutionIDError', { translationKey: 'InvalidInstitutionIDError', institutionID });
  }
}
